import { Col, Form, Modal, Row } from "react-bootstrap";
import useMultiLanguage from "../../../hook/useMultiLanguage";
import { GroupButton } from "../../components/GroupButton";
import { IAttribution } from "../../timesheet/models/timesheetModels";
import { NUMBER_SHEET_TIMESHEET_OVERVIEW } from "../../timesheet/constants/timesheetConsts";
import { useState } from "react";

interface IProps {
    open: boolean;
    list: IAttribution[];
    handleSave: (listAttribution: IAttribution[]) => void;
    handleClose: (reload?: boolean) => void
}

const DialogListAttribution = (props: IProps) => {
    const {
        open,
        list = [],
        handleSave = () => { },
        handleClose = () => { }
    } = props;

    const { lang } = useMultiLanguage();
    const [listAttribution, setListAttribution] = useState<IAttribution[]>(list);
    

    const handleCheck = (e: any, index: number) => {
        const isChecked = e.target.checked;
        setListAttribution(prevList => {
            return prevList.map((attr, i) => {
                if (i === index) {
                    return {
                        ...attr,
                        isShowed: isChecked 
                            ? (attr.isShowed ? [...attr.isShowed, NUMBER_SHEET_TIMESHEET_OVERVIEW] : [NUMBER_SHEET_TIMESHEET_OVERVIEW])
                            : attr.isShowed ? attr.isShowed.filter(num => num !== NUMBER_SHEET_TIMESHEET_OVERVIEW) : []
                    };
                }
                return attr;
            });
        });
    };

    if (!open) return <></>

    return (
        <Modal
            show={open}
            onHide={() => {
                handleClose();
            }}
            backdrop="static"
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {`${lang("TYPE_ATTRIBUTION")}`}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    {listAttribution.map((attribution, index) => {
                        return (
                            <Col xs={12} md={6} lg={6} key={`attribution-${index}`} className="mb-5">
                                <Form.Group className="d-flex">
                                    <Form.Check
                                        type="checkbox"
                                        label={
                                            <span>{attribution.name}</span>
                                        }
                                        value={attribution.name}
                                        checked={attribution.isShowed ? !!attribution.isShowed.includes(NUMBER_SHEET_TIMESHEET_OVERVIEW) : false}
                                    onChange={(e: any) => handleCheck(e, index)}
                                    />
                                </Form.Group>
                            </Col>
                        );
                    })}
                </Row>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
                <GroupButton
                    type="btn-save"
                    handleSubmit={() => {
                        handleSave(listAttribution);
                    }}
                />
                <GroupButton
                    type="btn-cancel"
                    handleCloseUpdateDialog={() => {
                        handleClose();
                    }}
                />
            </Modal.Footer>
        </Modal>
    )
};

export default DialogListAttribution;